// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"74355150","226":"74355150","565":"74355150","599":"74355150","773":"af913820"}[chunkId] + ".chunk.css";
};